import React from "react";

import { AssignsCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function assigns({ width, onResize }: Column.Options) {
	return base(ColumnId.Assigns, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default assigns;
